import { Link } from 'react-router-dom';
import CategoryCards from './components/CategoryCards';
import FeaturedArticles from './components/FeaturedArticles';
import FAQ from './components/FAQ';
import Newsletter from './components/Newsletter';

export default function Home() {
  return (
    <>
      {/* Schema.org Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '朋友的姐姐 - 青春情感记忆平台',
            url: typeof window !== 'undefined' ? window.location.origin : '',
            description: '探索青春懵懂情感，重温那段藏在心底的成长记忆。关注朋友的姐姐情感故事、青春期心理分析与成长经历。',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: `${typeof window !== 'undefined' ? window.location.origin : ''}/search?q={search_term_string}`,
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '朋友的姐姐',
            url: typeof window !== 'undefined' ? window.location.origin : '',
            description: '专注于青春期情感心理、成长记忆与青春文学的内容平台。',
            sameAs: [],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '朋友的姐姐 - 青春情感记忆平台首页',
            description: '探索青春懵懂情感，重温那段藏在心底的成长记忆。深度探讨朋友姐姐情感故事、青春期心理分析与成长经历。',
            url: typeof window !== 'undefined' ? window.location.href : '',
            isPartOf: {
              '@type': 'WebSite',
              name: '朋友的姐姐',
              url: typeof window !== 'undefined' ? window.location.origin : '',
            },
          }),
        }}
      />

      {/* Hero Section */}
      <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
        <img
          src="https://catscloud.cn/api/search-image?query=Warm%20nostalgic%20sunset%20scene%20with%20golden%20light%20filtering%20through%20trees%2C%20soft%20dreamy%20atmosphere%2C%20two%20young%20figures%20in%20distance%2C%20amber%20and%20cream%20color%20palette%2C%20artistic%20illustration%20style%2C%20emotional%20youth%20memory%20aesthetic%2C%20tender%20warm%20lighting%2C%20quiet%20suburban%20street%20with%20blooming%20flowers&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="青春记忆"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
        <div className="relative z-10 text-center w-full px-4 md:px-6">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6">
            朋友的姐姐
          </h1>
          <p className="text-base md:text-xl text-white/90 max-w-2xl mx-auto mb-8 leading-relaxed">
            那段青涩又温柔的成长记忆，藏在心底的青春故事。<br className="hidden sm:block" />
            一起探讨青春期情感心理，重温懵懂年代的心跳瞬间。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/qinggan-gushi"
              className="px-6 py-2.5 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              阅读情感故事
            </Link>
            <Link
              to="/about"
              className="px-6 py-2.5 rounded-lg bg-white/20 text-white text-sm font-medium hover:bg-white/30 backdrop-blur-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              了解我们
            </Link>
          </div>
        </div>
      </section>

      {/* Category Cards */}
      <CategoryCards />

      {/* Featured Articles */}
      <FeaturedArticles />

      {/* FAQ */}
      <FAQ />

      {/* Newsletter */}
      <Newsletter />
    </>
  );
}